
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.99 2.378C10.21 1.394 8.272.522 6.109.522 3.269.522.972 1.988.408 3.362v14.325c0 .78.502 1.077 1.066 1.077.441 0 .708-.134.984-.349.585-.502 1.764-1.18 3.65-1.18 1.898 0 3.22.657 3.733 1.119.267.215.585.41 1.149.41.564 0 .882-.216 1.148-.41.554-.431 1.846-1.118 3.733-1.118 1.897 0 3.076.687 3.66 1.179.277.215.534.349.974.349.564 0 1.077-.298 1.077-1.077V3.362c-.564-1.374-2.871-2.84-5.711-2.84-2.154 0-4.092.872-4.881 1.856zM2.059 3.854C2.294 3.22 3.78 2.07 6.109 2.07c2.338 0 3.855 1.159 4.06 1.784v12.972c-.974-.728-2.46-1.139-4.06-1.139-1.59 0-3.076.41-4.05 1.18V3.854zm17.872 0v13.013c-.984-.77-2.46-1.18-4.06-1.18-1.6 0-3.077.41-4.05 1.139V3.854c.204-.625 1.722-1.784 4.05-1.784 2.338 0 3.824 1.149 4.06 1.784z","fill":"#2E7CF6"}})])
          )
        }
      }
    